import { useState } from "react";
//mui
import { Button, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
//components
import BaseModal from '../Modal';
import CustomButton from "../buttons/CustomButton";
//utils
import { postReqOptBuilder } from "../../utils/main_utils";
//constants
import { para_be } from '../../config';



const SELECTION_OPTIONS = {
    move_in: "Move-In",
    periodical: "Periodical",
    quarterly: "Quarterly",
    semi_annual: "Semi-Annual",
    annual: "Annual",
    pre_move_out: "Pre Move-Out",
    move_out: "Move-Out",
    turn: "Turn",
};


const ChangeInspectionTypeModal = ({ open, handleClose, onSuccess, setNotifState, rid, initialValue='' }) => {
    const [loading, setLoading] = useState(false);
    const [selectedType, setSelectedType] = useState(initialValue);
    
    const handleSave = () => {
        setLoading(true);
        setNotifState(null);
        if (selectedType === initialValue) {
            setNotifState({text: "Nothing to change", type: "success"});
            setLoading(false);
            handleClose();
            return;
        }

        console.log("Updating inspection type from:", initialValue, " | to:", selectedType);
        fetch(`${para_be}/reports/update_inspection_type`, postReqOptBuilder({report_id: rid, inspection_type: selectedType}))
        .then((response) => response.json())
        .then((response) => {
            if (response.status === 200) {
                setNotifState({text: "Inspection type updated successfully", type: "success"});
                onSuccess(selectedType);
                handleClose();
            } else {
                setNotifState({text: response.msg, type: "error"});
            }
            setLoading(false);
        })
        .catch((error) => {
            console.log(error);
            setNotifState({text: "An error has occurred, please try again later", type: "error"});
            setLoading(false);
        });
    };

    
    return (
        <BaseModal
            open={open}
            onClose={handleClose}
            maxWidth={800}
        >
            <div className="p-6 max-w-md mx-auto bg-white">
                <div className="flex flex-col space-y-6">
                    <Typography variant="h6" className="mb-4 text-gray-800 font-semibold">
                        Change Inspection Type
                    </Typography>
                    <FormControl fullWidth className="mb-6">
                        <InputLabel id="inspection-type-label">Inspection Type</InputLabel>
                        <Select
                            labelId="inspection-type-label"
                            value={selectedType}
                            label="Inspection Type"
                            onChange={(e) => setSelectedType(e.target.value)}
                        >
                            {Object.keys(SELECTION_OPTIONS).map((k) => {
                                return (
                                    <MenuItem key={k} value={SELECTION_OPTIONS[k]}>
                                        {SELECTION_OPTIONS[k]}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                    
                    <div className="flex justify-end gap-3">
                        <Button 
                            variant="contained"
                            sx={{
                                backgroundColor: '#fff', 
                                strokeWidth: '1px',
                                stroke: '#F2F2F3',
                                fontSize: '12px',
                                textTransform: 'none',
                                borderRadius: '8px',
                                padding: '9px 15px',
                                color: '#0C1222',
                                minWidth: 0,
                                '&:hover': {
                                    backgroundColor: '#F7F7F7', 
                                },
                            }}
                            disabled={loading}
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <CustomButton 
                            variant="contained"
                            sx={{
                                backgroundColor: '#4F46E5', 
                                color: 'white',
                                fontSize: '12px',
                                textTransform: 'none',
                                borderRadius: '8px',
                                padding: '9px 15px',
                                '&:hover': { backgroundColor: '#4338CA' } 
                            }}
                            disabled={selectedType === initialValue}
                            loading={loading}
                            onClick={handleSave}
                        >
                            Save
                        </CustomButton>
                    </div>
                </div>
            </div>
        </BaseModal>
    )
}

export default ChangeInspectionTypeModal;